import { CommonModule } from '@angular/common';
import {
  Component,
  OnDestroy,
  AfterContentChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from '@sharedModule/material/material.module';
import { LoaderService } from '@sharedModule/services/loader/loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MaterialModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, AfterContentChecked {
  title = 'xbp-partner-portal';
  isAuth = false;
  onDestroy$ = new Subject<boolean>();

  constructor(
    public loaderService: LoaderService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
